import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-navigation-button',
  templateUrl: './navigation-button.component.html',
  styleUrls: ['./navigation-button.component.scss']
})
export class NavigationButtonComponent implements OnInit {

  @Input() title = '';
  @Input() text = '';
  @Input() icon = '';
  @Input() isSelected = false;

  constructor() { }

  getName(name: string) {
    return name.replace(/ /g, '');
  }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/navigation-button/navigation-button.component.ts